module.exports = __webpack_public_path__ + "static/laptop-536768045dde130fe61cc6de241a6e42.jpg";